import * as React from "react";
import {
  ContentItem,
  ContentItemLink,
  ContentItemVideo,
} from "../../../types/UIConfig";
import { Link } from "@chakra-ui/react";
import { VideoPlayer, toExternalUrl } from "../../../components/VideoPlayer";

type Props = {
  contentItem: ContentItem;
  value: string;
};

function isContentItemLink(
  contentItem: ContentItem
): contentItem is ContentItemLink {
  return "type" in contentItem && contentItem.type === "website";
}

function isContentItemVideo(
  contentItem: ContentItem
): contentItem is ContentItemVideo {
  return "type" in contentItem && contentItem.type === "video";
}

export const FormattedContentItem = ({
  contentItem,
  value,
}: Props): React.ReactElement => {
  if (isContentItemVideo(contentItem)) {
    return (
      <VideoPlayer
        url={value}
        aspectRatio={contentItem.aspectRatio}
        title={contentItem.label}
      />
    );
  }

  if (isContentItemLink(contentItem)) {
    return (
      <Link href={toExternalUrl(value)} isExternal={contentItem.opensNewTab}>
        {value}
      </Link>
    );
  }

  return <>{value}</>;
};
